import apiService from '../utils/apiService';

import {
  ADD_VEHICLE_MODEL ,
   ADD_VEHICLE_MODEL_START,
  ADD_VEHICLE_MODEL_ERROR ,
  UPDATE_VEHICLE_MODEL,
  UPDATE_VEHICLE_MODEL_START,
  UPDATE_VEHICLE_MODEL_ERROR,
  GET_VEHICLE_MODEL,
  GET_VEHICLE_MODEL_START,
  GET_VEHICLE_MODEL_ERROR,
 GET_VEHICLE_MODEL_LIST,
  GET_VEHICLE_MODEL_LIST_START,
  GET_VEHICLE_MODEL_LIST_ERROR,
  GET_VEHICLE_MODEL_LIST_PAGEABLE,
  GET_VEHICLE_MODEL_LIST_PAGEABLE_START,
  GET_VEHICLE_MODEL_LIST_PAGEABLE_ERROR,
  DELETE_VEHICLE_MODEL,
 DELETE_VEHICLE_MODEL_START,
  DELETE_VEHICLE_MODEL_ERROR,
  CLEAR_ERROR_VEHICLE_MODEL,
  GET_VEHICLE_MODEL_BY_BRAND_ID,
  GET_VEHICLE_MODEL_BY_BRAND_ID_START,
  GET_VEHICLE_MODEL_BY_BRAND_ID_ERROR,
} from './types';

import {
  vehicleModelAddPath,
  vehicleModelUpdatePath,
  vehicleModelFindByIdPath,
  vehicleModelFindAllPath,
  vehicleModelDeletePath,
  vehicleModelFindAllPageablePath,
  vehicleModelFindByBrandIdPath,
} from '../constants/apiEndpoints';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import { ModalForAddOrUpdateVehicleModel } from '../enums/VehicleModelEnums';
import { ServerMessagesEnums } from '../enums/ServerMessagesEnums';

const clearError = () => {
  return {
    type: CLEAR_ERROR_VEHICLE_MODEL,
  };
};

const addVehicleModelStart = () => {
  return {
    type: ADD_VEHICLE_MODEL_START,
  };
};
const addVehicleModelSuccessfully = (data) => {
  return {
    type: ADD_VEHICLE_MODEL,
    payload: data,
  };
};
const addVehicleModelUnsuccessfully = (err) => {
  return {
    type: ADD_VEHICLE_MODEL_ERROR,
    payload: err,
  };
};

const updateVehicleModelStart = () => {
  return {
    type: UPDATE_VEHICLE_MODEL_START,
  };
};
const updateVehicleModelSuccessfully = (data) => {
  return {
    type: UPDATE_VEHICLE_MODEL,
    payload: data,
  };
};
const updateVehicleModelUnsuccessfully = (err) => {
  return {
    type: UPDATE_VEHICLE_MODEL_ERROR,
    payload: err,
  };
};

const getVehicleModelStart = () => {
  return {
    type: GET_VEHICLE_MODEL_START,
  };
};
const getVehicleModelSuccessfully = (data) => {
  return {
    type: GET_VEHICLE_MODEL,
    payload: data,
  };
};
const getVehicleModelUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_MODEL_ERROR,
    payload: err,
  };
};

const getVehicleModelPageableListStart = () => {
  return {
    type: GET_VEHICLE_MODEL_LIST_PAGEABLE_START,
  };
};

const getVehicleModelPageableListSuccessfully = (pageResponseData) => {
  return {
    type: GET_VEHICLE_MODEL_LIST_PAGEABLE,
    payload: pageResponseData,
  };
};

const getVehicleModelListPageableUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_MODEL_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

const deleteVehicleModelStart = () => {
  return {
    type: DELETE_VEHICLE_MODEL_START,
  };
};
const deleteVehicleModelSuccessfully = (id) => {
  return {
    type: DELETE_VEHICLE_MODEL,
    payload: id,
  };
};
const deleteVehicleModelUnsuccessfully = (err) => {
  return {
    type: DELETE_VEHICLE_MODEL_ERROR,
    payload: err,
  };
};

const getVehicleModelListStart = () => {
  return {
    type: GET_VEHICLE_MODEL_LIST_START,
  };
};
const getVehicleModelListSuccessfully = (data) => {
  return {
    type: GET_VEHICLE_MODEL_LIST,
    payload: data,
  };
};
const getVehicleModelListUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_MODEL_LIST_ERROR,
    payload: err,
  };
};


const getVehicleModelByBrandIdStart = () => {
  return {
    type: GET_VEHICLE_MODEL_BY_BRAND_ID_START,
  };
};
const getVehicleModelByBrandIdSuccessfully = (data) => {
  return {
    type: GET_VEHICLE_MODEL_BY_BRAND_ID,
    payload: data,
  };
};
const getVehicleModelByBrandIdUnsuccessfully = (err) => {
  return {
    type: GET_VEHICLE_MODEL_BY_BRAND_ID_ERROR,
    payload: err,
  };
};



export const createVehicleModel = (vehicleModel, callback) => {
  return (dispatch) => {
    dispatch(addVehicleModelStart());
    return apiService
      .post(vehicleModelAddPath(), vehicleModel)
      .then((response) => {
        dispatch(addVehicleModelSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateVehicleModel.saveSuccessMessage,
          vehicleModel
        );
        callback();
      })
      .catch((err) => {
        dispatch(addVehicleModelUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const updateVehicleModel = (vehicleModel, callback) => {
  return (dispatch) => {
    dispatch(updateVehicleModelStart());
    return apiService
      .post(vehicleModelUpdatePath(), vehicleModel)
      .then((response) => {
        dispatch(updateVehicleModelSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateVehicleModel.updateSuccessMessage,
          vehicleModel
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateVehicleModelUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findAllVehicleModelPageble = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getVehicleModelPageableListStart());
    return apiService
      .get(vehicleModelFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        const pageResponseData = {
          pageNumber: response.data.number,
          emptyList: response.data.empty,
          isFirstPage: response.data.first,
          isLastPage: response.data.last,
          list: response.data.content,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements,
        };
        dispatch(getVehicleModelPageableListSuccessfully(pageResponseData));
      })
      .catch((err) => {
        dispatch(getVehicleModelListPageableUnsuccessfully(err));
      });
  };
};

export const findVehicleModelById = (id) => {
  return (dispatch) => {
    dispatch(getVehicleModelStart());
    return apiService
      .get(vehicleModelFindByIdPath(id))
      .then((response) => {
        dispatch(getVehicleModelSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getVehicleModelUnsuccessfully(err));
      });
  };
};


export const deleteVehicleModel = (id) => {
  return (dispatch) => {
    dispatch(deleteVehicleModelStart());
    return apiService
      .delete(vehicleModelDeletePath(id))
      .then(() => {
        dispatch(deleteVehicleModelSuccessfully(id));
        handleServerSuccessMessage(
          ModalForAddOrUpdateVehicleModel.deleteSuccessMessage,
          { id }
        );
      })
      .catch((err) => {
        dispatch(deleteVehicleModelUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.status === 404
            ? ServerMessagesEnums.deleteErrorMessage404
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorVehicleModel = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const findAllVehicleModel = () => {
  return (dispatch) => {
    dispatch(getVehicleModelListStart());
    return apiService
      .get(vehicleModelFindAllPath())
      .then((response) => {
        dispatch(getVehicleModelListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getVehicleModelListUnsuccessfully(err));
      });
  };
};

export const findVehicleModelByBrandId = (id) => {
  return (dispatch) => {
    dispatch(getVehicleModelByBrandIdStart());
    return apiService
      .get(vehicleModelFindByBrandIdPath(id))
      .then((response) => {
        dispatch(getVehicleModelByBrandIdSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getVehicleModelByBrandIdUnsuccessfully(err));
      });
  };
};